import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReturnBatchInput, ReturnBatchList, ReturnBatchOptions, ReturnDetail, ReturnPreview, ReturnLadingSearch, ReturnLadingProducts } from './return-batch.types';

@Injectable({ providedIn: 'root' })
export class ReturnBatchesService {
  private readonly url = '/api/products/return_batches.php';
  constructor(private readonly http: HttpClient) {}
  options(): Observable<ReturnBatchOptions> {
    return this.http.get<ReturnBatchOptions>(this.url, { params: { action: 'options' } });
  }
  list(q: string, customer: string, offset: number): Observable<ReturnBatchList> {
    let params = new HttpParams().set('action', 'list').set('q', q).set('offset', offset);
    if (customer) { params = params.set('customer_contact_uuid', customer); }
    return this.http.get<ReturnBatchList>(this.url, { params });
  }
  detail(uuid: string): Observable<ReturnDetail> {
    return this.http.get<ReturnDetail>(this.url, { params: { action: 'detail', uuid } });
  }
  ladings(customer: string, q: string): Observable<ReturnLadingSearch> {
    return this.http.get<ReturnLadingSearch>(this.url, { params: { action: 'ladings', customer_contact_uuid: customer, q } });
  }
  ladingProducts(customer: string, uuid: string): Observable<ReturnLadingProducts> {
    return this.http.get<ReturnLadingProducts>(this.url, { params: { action: 'lading-products', customer_contact_uuid: customer, lading_uuid: uuid } });
  }
  preview(input: ReturnBatchInput): Observable<ReturnPreview> {
    return this.http.post<ReturnPreview>(this.url + '?action=preview', input);
  }
  import(input: ReturnBatchInput, key: string): Observable<ReturnDetail> {
    return this.http.post<ReturnDetail>(this.url + '?action=create', input,
      { headers: new HttpHeaders({ 'Idempotency-Key': key }) });
  }
}
